import api from './api';

const ownerPayoutService = {
  /**
   * Récupérer les virements du propriétaire avec filtres/pagination
   * @param {Object} params - page, limit, status, currency, sort_by, sort_order
   * @returns {Promise<Object>} { payouts, stats, pagination }
   */
  async getOwnerPayouts(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (params.page)       queryParams.append('page', params.page);
      if (params.limit)      queryParams.append('limit', params.limit);
      if (params.status)     queryParams.append('status', params.status);
      if (params.currency)   queryParams.append('currency', params.currency);
      if (params.sort_by)    queryParams.append('sort_by', params.sort_by);
      if (params.sort_order) queryParams.append('sort_order', params.sort_order);

      const response = await api.get(`/payouts/owner/my-payouts?${queryParams}`);
      // Backend wraps response in { success, data: { stats[], payouts, pagination } }
      const inner = response.data?.data || response.data;

      // Normalize stats array → flat object expected by StatsBar
      const statsArray = Array.isArray(inner.stats) ? inner.stats : [];
      const currency = statsArray[0]?.currency || 'EUR';
      const stats = {
        total_count:     statsArray.reduce((sum, s) => sum + parseInt(s.count || 0), 0),
        total_completed: statsArray
          .filter(s => s.status === 'completed')
          .reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0),
        total_pending:   statsArray
          .filter(s => ['pending', 'processing'].includes(s.status))
          .reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0),
        currency,
      };

      return {
        payouts:    inner.payouts || [],
        stats,
        pagination: {
          totalPages: inner.pagination?.pages || 1,
          ...inner.pagination,
        },
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des virements:', error);
      throw error;
    }
  },

  /**
   * Télécharger le PDF de reçu d'un virement
   * @param {string|number} payoutId - ID du virement
   * @returns {Promise<Blob>} Blob du PDF
   */
  async downloadPayoutPdf(payoutId) {
    try {
      const response = await api.get(`/payouts/owner/my-payouts/${payoutId}/pdf`, {
        responseType: 'blob',
        timeout: 60000,
      });

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      if (!response.data || response.data.size === 0) {
        throw new Error('Aucune donnée PDF reçue du serveur');
      }

      return response.data;
    } catch (error) {
      console.error('Erreur lors du téléchargement du PDF virement:', error);
      throw error;
    }
  },
};

export default ownerPayoutService;
